import { defineRecipe } from '@chakra-ui/react/styled-system';

const iconRecipe = defineRecipe({
  className: 'icon',
  base: {
    display: 'inline-block',
    lineHeight: '1em',
    flexShrink: '0',
    // No `color: currentcolor` here (Chakra's default icon recipe has it): as `.css-icon { color }` it ties on
    // specificity with a parent recipe's `_icon` rule (`.css-parent :where(svg) { color }`), so which one wins
    // comes down to stylesheet insertion order — e.g. BitkitButton's `secondary` icon token silently lost on
    // some renders. It's a no-op anyway, since `color` inherits.
    verticalAlign: 'middle',
  },
});

export default iconRecipe;
